import React from 'react'
import {Button, Modal, Spinner} from 'react-bootstrap'
import {useTheme} from '../../context/ThemeContext'

interface BoardInviteModalProps {
  show: boolean
  handleClose: () => void
  onAccept: () => void
  onAcceptAndGo: () => void
  onDecline?: () => void
  loading: boolean
  declineLoading?: boolean
  alreadyAccepted?: boolean
  isAlreadyMember?: boolean
  modalAlert?: {message: string; type: 'success' | 'danger'} | null
  inviteStatus?: string | null
  inviteStatusLoading?: boolean
}

const BoardInviteModal: React.FC<BoardInviteModalProps> = ({
  show,
  handleClose,
  onAccept,
  onAcceptAndGo,
  onDecline,
  loading,
  declineLoading,
  alreadyAccepted,
  isAlreadyMember,
  modalAlert,
  inviteStatus,
  inviteStatusLoading,
}) => {
  const {theme} = useTheme()
  return (
    <Modal
      contentClassName={theme === 'dark' ? 'theme__div' : ''}
      show={show}
      onHide={handleClose}
      centered
    >
      <Modal.Header>
        <Modal.Title className={`${theme === 'dark' ? 'white__text' : ''}`}>
          Board Invitation
        </Modal.Title>
        <i
          className={`bi bi-x-lg modal-icon-custom ${theme === 'dark' && 'close'}`}
          onClick={handleClose}
        ></i>
      </Modal.Header>
      <Modal.Body>
        {inviteStatusLoading ? (
          <div className='d-flex justify-content-center py-4'>
            <Spinner animation='border' />
          </div>
        ) : (
          <p className={`text-center ${theme === 'dark' ? 'white__text' : ''}`}>
            {inviteStatus === 'accepted' || isAlreadyMember
              ? 'You are already a member of this board.'
              : inviteStatus === 'decline'
              ? 'You have already declined this invitation.'
              : alreadyAccepted
              ? 'Invitation already accepted!'
              : 'You have been invited to a board. What would you like to do?'}
          </p>
        )}
      </Modal.Body>
      <Modal.Footer className='d-flex flex-column align-items-center gap-2'>
        {!inviteStatusLoading && (
          <div className='d-flex justify-content-center flex-wrap gap-2'>
            {inviteStatus === 'accepted' || isAlreadyMember ? (
              <Button variant='primary' onClick={onAcceptAndGo}>
                Go to Board
              </Button>
            ) : inviteStatus === 'decline' ? (
              <Button variant='secondary' onClick={handleClose}>
                Close
              </Button>
            ) : alreadyAccepted ? (
              <Button variant='primary' onClick={onAcceptAndGo}>
                Go to Board
              </Button>
            ) : (
              <>
                <Button variant='success' onClick={onAccept} disabled={loading || declineLoading}>
                  {loading ? <Spinner animation='border' size='sm' /> : 'Accept Invitation'}
                </Button>
                {onDecline && (
                  <Button variant='danger' onClick={onDecline} disabled={loading || declineLoading}>
                    {declineLoading ? <Spinner animation='border' size='sm' /> : 'Decline Invitation'}
                  </Button>
                )}
                <Button variant='primary' onClick={onAcceptAndGo} disabled={loading || declineLoading}>
                  {loading ? <Spinner animation='border' size='sm' /> : 'Accept Invitation & Go to Board'}
                </Button>
              </>
            )}
          </div>
        )}
        {modalAlert && (
          <div className={`alert alert-${modalAlert.type} w-100 text-center mb-0 py-2`} role='alert'>
            {modalAlert.message}
          </div>
        )}
      </Modal.Footer>
    </Modal>
  )
}

export default BoardInviteModal
